import { stringify } from 'qs';
import IPagination from '../../../common/interfaces/IPagination';
import { getAuthAxiosInstance } from '../../../common/services/axios-config';
import IUsersFiltersModel from '../interfaces/IUsersFiltersModel';
import { IUsersResponse } from '../interfaces/IUsersResponse';
import { IUsersRequest } from '../interfaces/IUsersRequest';
import IUsersRequestsResponse from '../interfaces/IUsersRequestsResponse';
import IUsersRequestsRequest from '../interfaces/IUsersRequestsRequest';
import IUserRequestsFilterModel from '../interfaces/IUserRequestsFilterModel';

const getUsersList = async (
    page: number,
    pageSize: number,
    order: string,
    filters: IUsersFiltersModel,
): Promise<IPagination<IUsersResponse>> => {
    const request: IUsersRequest = {
        filters,
        _page: page,
        _size: pageSize,
        _order: order,
    };

    const Api = await getAuthAxiosInstance();

    const response = await Api.get('v1/users:paginated', {
        params: request,
        paramsSerializer(params) {
            return stringify(params, { allowDots: true });
        },
    }).catch(() => {
        throw new Error('Ocorreu um problema ao consultar os usuários');
    });

    if (response.data) {
        const { data } = response;
        return data;
    }

    return {} as IPagination<IUsersResponse>;
};

const getRequestsUsersList = async (
    page: number,
    pageSize: number,
    filters: IUserRequestsFilterModel,
): Promise<IPagination<IUsersRequestsResponse>> => {
    const request: IUsersRequestsRequest = {
        filters,
        _page: page,
        _size: pageSize,
    };

    const Api = await getAuthAxiosInstance();

    const response = await Api.get('v1/users-requests:paginated', {
        params: request,
        paramsSerializer(params) {
            return stringify(params, { allowDots: true });
        },
    }).catch(() => {
        throw new Error(
            'Ocorreu um problema ao consultar as solicitações de usuários',
        );
    });

    if (response.data) {
        const { data } = response;
        return data;
    }

    return {} as IPagination<IUsersRequestsResponse>;
};

const UsersManagementService = {
    getUsersList,
    getRequestsUsersList,
};

export default UsersManagementService;
